export interface TrackingGroupModel {
  groupId: string;
  grade: string;
  students: TrackingStudent[];
  timePeriodTitles: string[];
}

export interface TrackingStudent {
  studentId: string;
  name: string;
  surnames: string;
  grade: string;
  gradesPerPeriod: string[];
}

export interface ContentBlockGrade {
  id: string;
  title: string;
  grade: number;
  order: number;
}

export interface GradeReport {
  title: string;
  grade: number;
  steps: ContentBlockGrade[];
}

export interface TrackingStudentDetail {
  studentId: string;
  studentName: string;
  firstLastName: string;
  secondLastName: string;
  grade: number;
  timePeriods: StudentPeriodSteps[];
}

export interface StudentPeriodSteps {
  grade: number;
  title: string;
  steps: TrackingStudentStep[];
  timePeriodTemplateId: string;
}

export interface TrackingStudentStep {
  stepId: string;
  title: string;
  grade: number;
  activities: TrackingStudentActivity[];
}

export interface TrackingStudentActivity {
  activityId: string;
  typologyName: string;
  categoryName: string;
  grade: number;
}

export interface ActivityData {
  activityGrades: ActivityGrade[];
  stepName: string;
}

export interface ActivityCategory {
  name: string;
  typologies: string[];
}

export interface ActivityGrade {
  studentId: string;
  name?: string;
  surname?: string;
  grades: Grade[];
}

export interface Grade {
  categoryName: string;
  typologyName: string;
  activityId: string;
  grade: number | null;
  totalSavedExercises: number;
  totalExercises: number;
}
